/**
 * Algunas APIs devuelven HTTP 200 con cuerpo { hasErrors, errors, oblea } cuando no hay PDF.
 * Esta capa unifica el control antes de tratar `oblea` como base64 de archivo.
 */

function pushMessage(collector, message) {
  if (message != null && String(message).trim() !== "") {
    collector.push(String(message).trim());
  }
}

function collectFromErrorsList(list) {
  const messages = [];
  if (!Array.isArray(list)) return messages;
  for (const e of list) {
    if (!e) continue;
    if (typeof e === "string") {
      pushMessage(messages, e);
      continue;
    }
    const m = e.message ?? e.Message ?? e.errorMesage ?? e.ErrorMesage;
    if (m) {
      pushMessage(messages, m);
      continue;
    }
    if (e.item1 != null || e.item2 != null) {
      const joined = [e.item1, e.item2].filter((x) => x != null && String(x) !== "").join(" ");
      pushMessage(messages, joined);
    }
  }
  return messages;
}

/**
 * `oblea` a veces viene en base64 con un JSON de error p.ej. { code, message } o { codigo, mensaje }.
 */
function messageFromObleaBase64(oblea) {
  if (typeof oblea !== "string" || oblea.length > 8000) return null;
  try {
    const json = atob(oblea);
    if (!/^\s*\{/.test(json)) return null;
    const parsed = JSON.parse(json);
    if (!parsed || typeof parsed !== "object") return null;
    const code = parsed.code ?? parsed.Code ?? parsed.codigo ?? parsed.Codigo;
    const msg = parsed.message ?? parsed.Message ?? parsed.mensaje ?? parsed.Mensaje;
    if (msg == null) return null;
    if (code != null && (Number(code) >= 400 || Number(code) === 404)) return String(msg);
    if (Object.keys(parsed).length <= 3 && (parsed.message || parsed.mensaje)) return String(msg);
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {*} data cuerpo JSON de la respuesta de oblea
 * @returns {{ failed: false } | { failed: true, messages: string[] }}
 */
export function getObleaResponseFailure(data) {
  if (data == null || typeof data !== "object") {
    return { failed: true, messages: ["Respuesta inválida"] };
  }

  const hasErrorFlag = data.hasErrors === true;
  const hasErrorItems =
    (Array.isArray(data.errors) && data.errors.length > 0) ||
    (Array.isArray(data.errores) && data.errores.length > 0);

  if (hasErrorFlag || hasErrorItems) {
    let messages = [
      ...collectFromErrorsList(data.errors),
      ...collectFromErrorsList(data.errores)
    ];
    if (!messages.length) {
      const fromOblea = messageFromObleaBase64(data.oblea);
      if (fromOblea) messages = [fromOblea];
    }
    if (!messages.length) {
      messages = ["No se pudo obtener la oblea de envío"];
    }
    return { failed: true, messages };
  }

  const onlyObleaError = messageFromObleaBase64(data.oblea);
  if (onlyObleaError) {
    return { failed: true, messages: [onlyObleaError] };
  }

  if (data.oblea == null || data.oblea === "") {
    return { failed: true, messages: ["No hay oblea disponible"] };
  }

  return { failed: false };
}

export function createObleaValidationRejection(failure) {
  const err = new Error(failure.messages.join(" "));
  err.isObleaValidationError = true;
  err.messages = failure.messages;
  return err;
}
